module.exports = __webpack_public_path__ + "static/media/addBtn.ee93d655.png";